var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab',_vm._g(_vm._b({attrs:{"active-class":_vm.activeClass,"disabled":_vm.disabled,"exact":_vm.exact,"href":_vm.href,"link":_vm.link,"ripple":_vm.ripple,"to":_vm.to}},'v-tab',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }